import template from '../../mad-id.module.scss';
import animations from '@styles/animations.module.scss'
import { InView } from 'react-intersection-observer';
import style from './solution-section.module.scss'

interface IProblemProps {
    title: string;
    text: string[];
}

const SolutionSection = ({ title, text }: IProblemProps) => {
    return (
        <section className={`${template.section}`}>
            <div className={`${template.container} ${template.flex} ${template.flex_spacebetween}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${animations.scroll__animation} ${template.title} ${template.title_medium} ${template.margin_bot30px}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <div className={`${template.flex} ${template.flex_column} ${style.project__content}`}>
                    {
                        text.map((item: string, index: number) => {
                            return (
                                <InView key={index} triggerOnce={true}>
                                    {({ inView, ref, entry }: any) => {
                                        if (inView) {
                                            entry.target.classList.add(animations.active);
                                        }
                                        return (
                                            <div ref={ref} className={`${animations.scroll__animation} ${template.text} ${template.text_medium} ${template.margin_bot16px} ${style.project__text}`}>
                                                {item}
                                            </div>
                                        )
                                    }}
                                </InView>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default SolutionSection;
